// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GTiJM","card":"styles_card__WOp54"};